import styled from 'styled-components';

export default styled.div`
  font-size: 28px;
  float: right;
  
  .blank {
    color: #97a29c;
  }
  
  .fill {
    color: #000;
  }
`;
